import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    isLoggedIn: false,
    profile: {},
    activeArt: null,
    activeStory: null,
    zen: false,
    sidebarOpen: true,
  },
  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    profile: (state) => state.profile,
    activeArt: (state) => state.activeArt,
    activeStory: (state) => state.activeStory,
    zen: (state) => state.zen,
  },
  mutations: {
    login(state, payload) {
      state.isLoggedIn = true;
      state.profile = payload;
      router.push('/admin/stories');
    },
    logout(state) {
      state.isLoggedIn = false;
      state.profile = null;
      router.push('/admin/login');
    },
    setActiveArt(state, payload ) {
      state.activeArt = payload;
    },
    setActiveStory(state, payload) {
      state.activeStory = payload;
    },
    setZen(state, payload) {
      state.zen = payload;
    },
    setSidebar(state, payload) {
      state.sidebarOpen = payload;
    },
  },
  actions: {
    setActiveArt({commit}, payload ) {
      axios.get(`${this._vm.$API}/arts/${payload.id}`).then((response) => {
        commit('setActiveArt', response.data);
      });
    },
    setActiveStory({commit}, payload) {
      axios.get(`${this._vm.$API}/stories/${payload.id}`).then((response) => {
        commit('setActiveStory', response.data);
      });
    },
  },
});
